import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AvatarModule } from '../avatar/avatar.module';
import { UserEntity } from 'src/app/models/entities/user.entity';
import { BellComponent } from '../bell/bell.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-profile-menu',
    imports: [CommonModule, AvatarModule, BellComponent, MatButtonModule, MatIconModule],
    templateUrl: './profile-menu.component.html',
    styleUrl: './profile-menu.component.scss',
    standalone: true
})
export class ProfileMenuComponent {
  @Input() user!: UserEntity;
  @Input() notifications: number = 0;
  @Input() priorities: number = 0;
  @Input() chats: number = 0;
  @Output() profileClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() chatClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() prioritiesClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() notificationsClicked: EventEmitter<void> = new EventEmitter<void>();

  public previewUserProfile: string | null = null;

  getBadgeStyle(role: string): any {
    switch (role) {
      case 'Developer':
        return { backgroundColor: '#E6F2FB', color: '#3578BD' };
      case 'Tester':
        return { backgroundColor: '#FFF2CF', color: '#FCBA02' };
      case 'Project Manager':
        return { backgroundColor: '#E7F8FA', color: '#13B9CF' };
      case 'Client':
        return { backgroundColor: '#CFA9B1', color: '#CC4158' };
      case 'Designer':
        return { backgroundColor: '#FEEEEB', color: '#FD7B38' };
      default:
        return { backgroundColor: '#fff', color: '#fff' };
    }
  }
}
